import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { Item } from 'projects/app-misc/src/app/modules/admin-panel/data/item';

@JsonObject('model.ItemGroup')
export class ItemGroup extends AbstractModel {

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty([Item], 'items')
  items?: Item[]
}
